import API from "../api"
import { SessionService } from "./persistService"

const searchAddressByCep = async (cep) => {
    if (!cep) return
    cep = cep.replace(/\D+/g, '')

    if (cep.length >= 8) {
        let correctCep = ''
        for (let i = 0; i < 8; i++) correctCep += `${cep[i]}`

        try {
            const result = await API.addressByCep(correctCep)

            return {
                success: true,
                data: {
                    city: result.data.city,
                    district: result.data.district,
                    state: result.data.city.state
                }
            }
        } catch (err) {
            return {
                success: false,
                message: 'CEP inválido'
            }
        }
    }
}

export const getDeliveryPriceByCep = async (deliveryPrices = []) => {
    // Primeiro tenta utilizar o endereço fornecido pelo usuário
    const addressJson = SessionService.getItem('address')

    if (addressJson) {
        if (Object.hasOwn(addressJson, 'district')) {
            const dp = deliveryPrices.find((dp) => dp?.district?.id === addressJson.district.id)
            return dp ? parseFloat(dp.delivery_price) : null
        }
    }

    // Se não houver endereço fornecido, tenta utilizar o CEP colocado no modal amarelo
    const localCEP = SessionService.getItem('cep')
    const address = await searchAddressByCep(localCEP)
    let dp = null

    if (address && address.success) {
        const { city, district } = address.data

        if (district) {
            dp = deliveryPrices.find((dp) => dp?.district?.id === district.id)
        } else if (city) {
            // Se não houver distrito, tenta encontrar o preço de entrega pela cidade
            const dps = deliveryPrices
                .filter((dp) => dp?.district?.city_id === city.id)
                .sort((a, b) => b.delivery_price - a.delivery_price)

            if (dps.length > 0) {
                dp = dps[0]
            }
        }

        if (dp) {
            return parseFloat(dp.delivery_price)
        }
    }

    return null
}

export default searchAddressByCep;